import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class OrderProcessingService {
  // tslint:disable-next-line:typedef
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }



  getProductionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProductionPlan', data);
  }

  getUOMData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetUOM', data);
  }

  submitProductionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/SubmitProductionPlan', data);
  }

  getProductionPlanDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProductionPlanDetail', data);
  }

  getProducts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProducts', data);

  }



  submitProductionPlanDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/SubmitProductionPlanDetail', data);
  }

}